import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { SearchParamsForListing } from '@keaze/web/common/enums';
import { useSearchQueryParams } from '../../hooks';
import { FiltersState } from '../filters.types';

type ExpectedUseUpdateFiltersParams = void;

type UseUpdateFiltersParams = (
  data: FiltersState
) => ExpectedUseUpdateFiltersParams;

type ConvertBedroomsQueryParamsToArray = (bedrooms?: number[]) => number[];

const convertBedroomsQueryParamsToArray: ConvertBedroomsQueryParamsToArray = (
  bedrooms
) => {
  if (!bedrooms) {
    return [];
  }

  if (Array.isArray(bedrooms)) {
    return bedrooms;
  }

  return [bedrooms];
};

export const useUpdateFiltersParams: UseUpdateFiltersParams = (filters) => {
  const router = useRouter();

  const {
    paramsForListing: { bedrooms },
    updateParam,
  } = useSearchQueryParams();

  useEffect(() => {
    if (filters.bedrooms !== null) {
      const bedroomsFilters = filters.bedrooms as number[];
      const bedroomsQueryParams = convertBedroomsQueryParamsToArray(bedrooms);
      const difference = (bedroomsQueryParams ?? []).filter(
        (x) => !bedroomsFilters.includes(x)
      );

      if (difference.length !== 0) {
        updateParam({
          router,
          param: SearchParamsForListing.Bedrooms,
          value: filters.bedrooms,
        });
      }
    }
  }, [router, filters, bedrooms, updateParam]);
};
